import React, { useEffect, useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { TrustBadges } from '../ui/TrustBadges';
import { SectionHeader } from '../ui/SectionHeader';
export function Oferta() {
  const [timeLeft, setTimeLeft] = useState({
    h: 2,
    m: 0,
    s: 0
  });
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    let endTime = sessionStorage.getItem('countdown_end');
    if (!endTime) {
      endTime = (Date.now() + 2 * 60 * 60 * 1000).toString();
      sessionStorage.setItem('countdown_end', endTime);
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const distance = parseInt(endTime!) - now;
      if (distance <= 0) {
        clearInterval(interval);
        setIsExpired(true);
      } else {
        setTimeLeft({
          h: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          m: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          s: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  const includes = [<>
      Ebook <strong data-id="element-256">Reflujo Cero en 72h</strong> — el paso a paso completo para
      resetear tu sistema digestivo
    </>, <>
      <strong data-id="element-257">Mecanismo Cardias-Lock™</strong> — los ejercicios de respiración
      técnica para cerrar la válvula mecánicamente
    </>, <>
      <strong data-id="element-258">Protocolo de Choque de 3 Días</strong> — el cronograma exacto de
      qué comer y qué hacer hora por hora
    </>, <>
      Mapa de Detonantes Reales — identificá tus disparadores nivel 1 antes de
      que quemen
    </>, <>
      Rutina Nocturna "Dormir Plano" — configurá tu descanso para que la
      gravedad trabaje a tu favor
    </>, <>
      <strong data-id="element-259">BONO 1:</strong> Lista Negra del Reflujo
    </>, <>
      <strong data-id="element-260">BONO 2:</strong> Guía Express de Cena Sin Castigo
    </>, <>
      <strong data-id="element-261">BONO 3:</strong> Protocolo de Emergencia Anti-Agrura
    </>, <>Acceso inmediato — descargable al instante vía Mercado Pago</>, <>Garantía de 7 días — o te devolvemos el dinero, sin preguntas</>];
  return <section id="oferta" className="py-[100px] bg-gradient-to-b from-[#1a0f08] to-[#120806]" data-id="element-262">
      <div className="container-custom" data-id="element-263">
        <SectionHeader eyebrow="Tu inversión" title={<>
              Todo lo que obtenés
              <br data-id="element-265" />
              <span className="text-gold" data-id="element-266">hoy mismo</span>
            </>} data-id="element-264" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[960px] mx-auto mt-[60px]" data-id="element-267">
          {/* Left Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/5 border border-gold/15 rounded-[12px] p-8 md:p-9" data-id="element-268">
            <p className="text-[11px] tracking-[2px] uppercase text-gold mb-6 font-semibold" data-id="element-269">
              Incluido en tu compra
            </p>
            <div className="flex flex-col gap-3.5" data-id="element-270">
              {includes.map((item, i) => <div key={i} className="flex gap-2.5 items-start text-[14px] text-gray-light leading-[1.5]" data-id="element-271">
                  <span className="text-gold font-bold text-[16px] shrink-0 mt-px" data-id="element-272">
                    ✓
                  </span>
                  <span data-id="element-273">{item}</span>
                </div>)}
            </div>
          </motion.div>

          {/* Right Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-gold/15 to-gold/5 border border-gold/30 rounded-[12px] p-8 md:p-9 text-center relative overflow-hidden flex flex-col items-center" data-id="element-274">
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-gold to-gold-light" data-id="element-275" />

            <div className="bg-gold/10 border border-gold/30 rounded-[8px] p-3 mb-6 w-full shadow-[0_0_20px_rgba(224,122,80,0.15)] animate-border-glow" data-id="element-276">
              <p className="text-[12px] text-gold font-semibold uppercase tracking-[1px] mb-1" data-id="element-277">
                Precio de lanzamiento termina en:
              </p>
              <div className="font-mono text-[24px] font-bold text-white tracking-wider" data-id="element-278">
                {isExpired ? '¡Oferta por tiempo limitado!' : `${formatTime(timeLeft.h)}:${formatTime(timeLeft.m)}:${formatTime(timeLeft.s)}`}
              </div>
            </div>

            <div className="w-[180px] mx-auto mb-6 animate-float" data-id="element-279">
              <img src="https://i.postimg.cc/9MBfVQ1x/libro-principal.webp" alt="Reflujo Cero en 72h" className="w-full h-auto animate-glow-pulse" loading="lazy" data-id="element-280" />
            </div>

            <p className="text-[11px] tracking-[2px] uppercase text-gold mb-6 font-semibold" data-id="element-281">
              Tu inversión hoy
            </p>

            <p className="text-[16px] text-gray line-through mb-2" data-id="element-282">
              Valor total: $42.000
            </p>

            <div className="font-display text-[52px] font-black bg-gradient-to-r from-gold to-gold-light bg-clip-text text-transparent leading-none mb-1" data-id="element-283">
              <span className="text-[22px] align-super" data-id="element-284">$</span>17.990
            </div>

            <p className="text-[13px] text-gray mb-7 leading-[1.5]" data-id="element-285">
              Pago único — acceso inmediato
              <br data-id="element-286" />
              Sin suscripciones ni costos adicionales
            </p>

            <div className="flex flex-col items-center gap-4 w-full" data-id="element-287">
              <Button href="#" variant="primary" fullWidth data-id="element-288">
                ACCEDER HOY AL PROTOCOLO →
              </Button>
              <TrustBadges data-id="element-289" />
            </div>

            <div className="mt-7 pt-5 border-t border-gold/15 w-full" data-id="element-290">
              <p className="text-[11px] text-gray tracking-[1px] uppercase mb-2.5" data-id="element-291">
                Formas de pago
              </p>
              <p className="text-[13px] text-gray" data-id="element-292">
                Tarjeta de crédito · Débito · Transferencia · Mercado Pago
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}